import { lazy } from 'react'
import { createAppFromCommonTemplate } from '@helpers'

const PromotionalBanner = lazy(() => import('@components/PromotionalBanner'))

const checkoutPromotionalBannerEl = document.getElementById(
  'checkout-promotional-banner',
)

export const renderPromotionalBannerApp = (promotionalBannerData: any) => {
  createAppFromCommonTemplate(
    checkoutPromotionalBannerEl,
    <PromotionalBanner
      text={promotionalBannerData?.text}
      hideCloseButton={promotionalBannerData?.hideCloseButton}
    />,
  )
}
